<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>Attributs</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-container">
                <mat-form-field>
                    <mat-select data-select-roles [(ngModel)]="result.selectedAttributes" multiple required #attributeselect placeholder="Ajouter des attributs...">
                        @for (attribute of data.attributes; track attribute.id) {
                            <mat-option [value]="attribute">
                                {{ attribute.header }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
    </mat-card-actions>
</mat-card>
